var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAuthBgImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 660,
    viewBox: "0 0 1440 660",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_267_806)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 660,
    fill: "#111315"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.5,
    cy: 676,
    rx: 293.5,
    ry: 247,
    fill: "#47C87A",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1796 13.5C1796 157.37 1671.98 274 1519 274C1366.02 274 1242 157.37 1242 13.5C1242 -130.37 1366.02 -247 1519 -247C1671.98 -247 1796 -130.37 1796 13.5Z",
    fill: "#47C87A",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M691.6 54L698.182 63H685.018L691.6 54Z",
    fill: "#00F863"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M260.6 232L267.182 241H254.018L260.6 232Z",
    fill: "#00F863"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M380.6 115L387.182 124H374.018L380.6 115Z",
    fill: "#00F863"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M93.6 273L100.182 282H87.0182L93.6 273Z",
    fill: "#00F863"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M137.6 121L144.182 130H131.018L137.6 121Z",
    fill: "#00F863"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1065.6 299L1072.18 308H1059.02L1065.6 299Z",
    fill: "#00F863"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1386.6 218L1393.18 227H1380.02L1386.6 218Z",
    fill: "#00F863"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M436.6 653L443.182 662H430.018L436.6 653Z",
    fill: "#00F863"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M727.6 588L734.182 597H721.018L727.6 588Z",
    fill: "#00F863"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1432.6 551L1439.18 560H1426.02L1432.6 551Z",
    fill: "#00F863"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1130.6 626L1137.18 635H1124.02L1130.6 626Z",
    fill: "#00F863"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1241.6 420L1248.18 429H1235.02L1241.6 420Z",
    fill: "#00F863"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1192.6 136L1199.18 145H1186.02L1192.6 136Z",
    fill: "#00F863"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1050.6 66L1057.18 75H1044.02L1050.6 66Z",
    fill: "#00F863"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M275.6 408L282.182 417H269.018L275.6 408Z",
    fill: "#00F863"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_267_806"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 660,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthBgImage);
export default __webpack_public_path__ + "static/media/AuthBgImage.2c39cc5a94edd5e69ac7d9e429c18684.svg";
export { ForwardRef as ReactComponent };